export const changedPropertyConfig = {
  bid: { shortName: 'Bid', formatType: 'currency' },
  'bidSetting.bidStrategy': { shortName: 'Bid Strategy', formatType: 'text' },
  'bidSetting.placementBidAdjustment.DETAIL_PAGE': {
    shortName: 'Placement Detail Page',
    formatType: 'percentInteger',
  },
  'bidSetting.placementBidAdjustment.HOME': {
    shortName: 'Placement Home',
    formatType: 'percentInteger',
  },
  'bidSetting.placementBidAdjustment.OTHER': {
    shortName: 'Placement Other',
    formatType: 'percentInteger',
  },
  'bidSetting.placementBidAdjustment.PLACEMENT_PRODUCT_PAGE': {
    shortName: 'Placement Product Page',
    formatType: 'percentInteger',
  },
  'bidSetting.placementBidAdjustment.PLACEMENT_REST_OF_SEARCH': {
    shortName: 'Placement Rest Of Search',
    formatType: 'percentInteger',
  },
  'bidSetting.placementBidAdjustment.PLACEMENT_TOP': {
    shortName: 'Placement Top',
    formatType: 'percentInteger',
  },
  'budget.budgetCap.monetaryBudget.amount': {
    shortName: 'Budget Cap Amount',
    formatType: 'currency',
  },
  endDateTime: { shortName: 'End Date', formatType: 'dateTime' },
  name: { shortName: 'Name', formatType: 'defaultText' },
  state: { shortName: 'State', formatType: 'text' },
};
